import { useEffect, useState } from 'react';
import classNames from 'classnames/bind';
import styles from './Contact.module.css';

import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

import Complete from '../Complete';

import {
  CHARACTER_COUNT,
  CONTACT_COMPLETE,
  CONTENT,
  ENTER,
  ENTERPRISE_CONTACT,
  ENTER_CONTENT,
  ENTER_TITLE,
  SEND,
  SERVICE_RESTRICTION_CONTACT,
  TITLE,
} from '../../../constants';
import { limitMaxLen } from '../../../utils/util';

import { useLocation, useNavigate } from 'react-router-dom';
import { useSetAccountInquiryMutation } from '../../../services/api';
import { useAppSelector } from '../../../hooks/useRedux';
import { selectUserId } from '../../../features/authSlice';
import { useSubmitMembershipInquiryMutation } from '../../../services/membership';

const contactSchema = yup.object({
  title: yup.string().required(),
  content: yup.string().required(),
  userId: yup.number().required(),
});

export default function Contact() {
  const cx = classNames.bind(styles);
  const { state } = useLocation();
  const userId = state?.info?.userId ?? useAppSelector(selectUserId);
  const navigate = useNavigate();

  const { register, getValues, watch } = useForm({
    mode: 'onBlur',
    resolver: yupResolver(contactSchema),
    defaultValues: {
      title: '',
      content: '',
      ...(state && { userId }),
    },
  });

  const [isComplete, setIsComplete] = useState(false);
  const [email, setEmail] = useState('');

  const [submitInquiry] = (
    state ? useSetAccountInquiryMutation : useSubmitMembershipInquiryMutation
  )();

  const submit = async () => {
    try {
      const data: any = await submitInquiry(getValues()).unwrap();
      setEmail(data.email);
    } catch (error) {
      console.error('Failed to submit', error);
    }
    setIsComplete(true);
  };

  useEffect(() => {
    if (!state) {
      navigate('/login/contact', { replace: true });
    }
  }, []);

  return (
    <>
      <h2>
        {isComplete
          ? `${CONTACT_COMPLETE}!`
          : state
          ? SERVICE_RESTRICTION_CONTACT
          : ENTERPRISE_CONTACT}
      </h2>
      {isComplete ? (
        <Complete name="contact" account={email} />
      ) : (
        <>
          <div className={cx('info_account')}>
            <div className={cx('board_form_area')}>
              <div className={cx('input_box')}>
                <span className={cx('blind')}>{TITLE}</span>
                <input
                  type="text"
                  title={`${TITLE} ${ENTER}`}
                  placeholder={ENTER_TITLE}
                  autoCapitalize="off"
                  {...register('title', {
                    onChange: ({ target }) =>
                      (target.value = limitMaxLen(target.value, 25)),
                  })}
                />
              </div>

              <div className={cx('input_box')}>
                <span className={cx('blind')}>{CONTENT}</span>
                <textarea
                  title={`${CONTENT} ${ENTER}`}
                  placeholder={ENTER_CONTENT}
                  {...register('content', {
                    onChange: ({ target }) =>
                      (target.value = limitMaxLen(target.value, 1000)),
                  })}
                ></textarea>
                <span className={cx('letter_length')}>
                  <span>{watch('content').length}</span>/1,000 {CHARACTER_COUNT}
                </span>
              </div>
            </div>
          </div>
          <div className={cx('btn_wrap', 'bottom')}>
            <button
              type="button"
              className={cx('btn', 'b_t', 's48', {
                'is--disabled':
                  !watch('title').trim() || !watch('content').trim(),
              })}
              onClick={submit}
            >
              <span>{SEND}</span>
            </button>
          </div>
        </>
      )}
    </>
  );
}
